import React, { useState } from 'react'
import { QueryKeys } from '../../utils/queryKeyGenerator'
import { handleGetRequest } from '../../utils/api-handler.util'
import { Link, useSearchParams } from 'react-router-dom'
import USER_TYPE from '../../constants/userType'
import { useAuth } from '../../contexts/AuthContext'
import { useQuery } from '@tanstack/react-query'
import CategoriesFilter from '../common/CategoriesFilter'
import ProductCard from '../products/ProductCard'

export default function AllProducts() {
  const [currentPage, setCurrentPage] = useState(1)
  const { currentUser } = useAuth()
  const userType = currentUser?.userType || USER_TYPE.guest
  const [searchParams] = useSearchParams()
  const category = searchParams.get('category') || null

  const { data: productsData } = useQuery({
    queryKey: QueryKeys.categoryProducts(category, userType, currentPage),
    queryFn: () =>
      handleGetRequest('/products/retail', {
        page: currentPage,
        categorySlug: category,
      }),
  })

  const allProducts = productsData?.data || []

  if (!allProducts?.length && !category) {
    return null
  }

  const renderProducts = () => {
    if (allProducts.length === 0) {
      return (
        <p className="text-center text-gray-500 col-span-full">
          No products found in this category.
        </p>
      )
    }

    return allProducts.map((product) => (
      <Link
        key={product.id}
        to={`/retailers/${product.shopSlug}/products/${product.productSlug}`}
        style={{ textDecoration: 'none' }}
        className="block hover:transform hover:scale-[1.02] transition-transform duration-200"
      >
        <ProductCard product={product} catalogProducts={true} />
      </Link>
    ))
  }

  return (
    <div className="bg-background  py-4 border-b border-dashed ">
      <CategoriesFilter setPage={setCurrentPage} />
      <div className="py-4 grid grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 gap-4 lg:gap-6">
        {renderProducts()}
      </div>

      <Link to="/products" className="mx-auto text-tertiary-600 block w-fit text-sm">
        View All Products
      </Link>
    </div>
  )
}
